import React, { useState } from 'react'
import './styles.scss'

const Accordion = (props) => {
  const [openIndexes, setOpenIndexes] = useState([0])
  const { items } = props

  const toggleFaq = (event, index) => {
    event.preventDefault()
    const indexOfExisting = openIndexes.indexOf(index)
    const clonedArr = [...openIndexes]
    if (indexOfExisting === -1) {
      clonedArr.push(index)
    } else {
      clonedArr.splice(indexOfExisting, 1)
    }
    setOpenIndexes(clonedArr)
  }

  return (
    <section className="faq">
      <div className="faq-accordion">
        {items.map((item, index) => (
          <AccordionItem
            key={item.question}
            itemIndex={index}
            toggleFaq={toggleFaq}
            openIndexes={openIndexes}
            question={item.question}
            answer={item.answer}
          />
        ))}
      </div>
    </section>
  )
}

const AccordionItem = (props) => {
  const { question, answer, toggleFaq, openIndexes, itemIndex } = props
  const active = openIndexes.indexOf(itemIndex) !== -1
  return (
    <div className={`faq-accordion-item ${active ? 'active' : 'inactive'}`}>
      <a className="faq-accordion-question" href="#toggle" onClick={(event) => toggleFaq(event, itemIndex)}>
        <h3>{question}</h3>
        <button className={`plus-minus ${active ? 'active' : 'inactive'}`} type="button">
          Toggle
        </button>
      </a>
      <div className="faq-accordion-answer">{answer}</div>
    </div>
  )
}

export default Accordion
